<div class="layout-auto-1-auto">
  <div class="app-section-header">
    <h2>Disposition</h2>
  </div>
  <div class="content">
    <div class="grid grid-auto-1 grid-full-height">
      <div class="width-400 content">
        <exg-data-list #SOlist [rowSource]="SummaryData.DL" selectKey="oeID"
                       (RowChange)="Config.SummaryData.rowChange($event)" [allowSingleSelection]="true"
        >
          <ng-template #rowTemplate let-oe>
            <div class="list-row-auto-1">
              <div></div>
              <div class="layout-auto-1-auto-grid-1-auto grid typo-small">
                <!--<div class="list-metadata" style="margin-left:0">
                  <div>
                    {{enumSvc.getEnumerationText('VorgangStatus', task.vorg_enmIdent_VorgangStatus)}} -
                    {{enumSvc.getEnumerationText('VorgangTyp', task.vorg_enmIdent_VorgangTyp)}}
                  </div>
                  <div>Auftraggeber: {{oe.auAuftraggeberShort}} Schadenart: {{enumSvc.getEnumerationText('Schadenart', oe.aue_enmIdent_SchadenArt)}}</div>
                </div>-->
                <div class="list-metadata ">
                  <!--<div
                    class="typo-right">{{task.vorgLCD | excDate: 'Globals.DateTimeFormatShort'}}</div>-->
                  <div class="typo-right">{{oe.marker?.oeName}}</div>
                </div>
                <div class="span-2">
                  <div class="grid-1-auto">
                    <div><strong>{{oe.oeEName}} {{oe.oeName}}</strong></div>
                    <div></div>
                  </div>
                </div>
                <div class="span-2 list-secondary-text">
                  <div>{{oe.adrStr}} {{oe.adrHNum}}</div>
                  <div>{{oe.adrPlz}} {{oe.adrOrt}}</div>
                  <div> {{oe.adrZusatz}}</div>
                </div>
              </div>
            </div>

          </ng-template>
        </exg-data-list>
      </div>
      <div class="content">
        <app-disposition-map2 [oeList]="SummaryData?.DL" [dispoDefinition]="SummaryData.DispositionListDefinitionValues">
                              <!--[task]="Config.SummaryData.selectedObjects[0]"-->
        </app-disposition-map2>
      </div>
    </div>

  </div>
  <div></div>
</div>
